import Swiper from 'swiper';
import {
    A11y,
    Autoplay,
    EffectFade,
    Navigation,
    Pagination,
} from 'swiper/modules';

function bindAutoplayControl(swiper, button) {
    if (!button) {
        return;
    }

    const label = button.querySelector('.visually-hidden');
    const pauseLabel = button.dataset.pauseLabel || 'Pause slideshow';
    const playLabel = button.dataset.playLabel || 'Play slideshow';

    const updateButton = (isPaused) => {
        const text = isPaused ? playLabel : pauseLabel;
        button.classList.toggle('is-paused', isPaused);
        button.setAttribute('aria-label', text);
        button.setAttribute('aria-pressed', String(isPaused));

        if (label) {
            label.textContent = text;
        }
    };

    button.addEventListener('click', () => {
        if (swiper.autoplay.running) {
            swiper.autoplay.stop();
            updateButton(true);
        } else {
            swiper.autoplay.start();
            updateButton(false);
        }
    });

    updateButton(false);
}

document.addEventListener('DOMContentLoaded', () => {
    // Related products
    document.querySelectorAll('.swiperProductsSlider').forEach((slider) => {
        const container = slider.closest('.swiperProductsBlock');

        new Swiper(slider, {
            modules: [Navigation, A11y],
            a11y: {
                enabled: true,
            },
            navigation: {
                nextEl: container.querySelector('.swiperProductsNext'),
                prevEl: container.querySelector('.swiperProductsPrev'),
            },
            slidesPerView: 1,
            breakpoints: {
                500: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
                1400: {
                    slidesPerView: 4,
                },
            },
        });
    });

    // Links
    document.querySelectorAll('.swiperLinksSlider').forEach((slider) => {
        const container = slider.closest('.swiperLinksBlock');

        new Swiper(slider, {
            modules: [Navigation, A11y],
            a11y: {
                enabled: true,
            },
            loop: true,
            navigation: {
                nextEl: container.querySelector('.swiperLinksNext'),
                prevEl: container.querySelector('.swiperLinksPrev'),
            },
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                578: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },
        });
    });

    // Publications
    document.querySelectorAll('.swiperPublicationsSlider').forEach((slider) => {
        const container = slider.closest('.swiperPublicationsBlock');

        new Swiper(slider, {
            modules: [Navigation, A11y],
            a11y: {
                enabled: true,
            },
            loop: true,
            navigation: {
                nextEl: container.querySelector('.swiperPublicationsNext'),
                prevEl: container.querySelector('.swiperPublicationsPrev'),
            },
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                992: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
            },
        });
    });

    // Gallery
    document.querySelectorAll('.swiperGallerySlider').forEach((slider) => {
        const container = slider.closest('.swiperGalleryBlock');
        const slideCount = slider.querySelectorAll('.swiper-slide').length;

        const swiper = new Swiper(slider, {
            modules: [Navigation, A11y, EffectFade],
            a11y: {
                enabled: true,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: slideCount > 1,
            navigation: {
                nextEl: container.querySelector('.swiperGalleryNext'),
                prevEl: container.querySelector('.swiperGalleryPrev'),
            },
            slidesPerView: 1,
        });

        const previousButton = container.querySelector('.swiperGalleryPrev');
        const nextButton = container.querySelector('.swiperGalleryNext');
        const updateGalleryNavigation = () => {
            const navigationDisabled = previousButton.classList.contains('swiper-button-disabled')
                && nextButton.classList.contains('swiper-button-disabled');

            previousButton.hidden = navigationDisabled;
            nextButton.hidden = navigationDisabled;
        };

        updateGalleryNavigation();
        swiper.on('lock unlock update resize', updateGalleryNavigation);
    });

    // Alternate gallery
    document.querySelectorAll('.swiperGalleryAltSlider').forEach((slider) => {
        const container = slider.closest('.swiperGalleryAltBlock');
        const currentSlide = container.querySelector('.swiperGalleryAltCurrent');
        const totalSlides = container.querySelector('.swiperGalleryAltTotal');
        const slideCount = slider.querySelectorAll('.swiper-slide').length;

        totalSlides.textContent = String(slideCount);
        if (slideCount <= 1) {
            container.querySelector('.slider-gallery-alt-item-number').hidden = true;
        }

        const swiper = new Swiper(slider, {
            modules: [Navigation, A11y, EffectFade],
            a11y: {
                enabled: true,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            navigation: {
                nextEl: container.querySelector('.swiperGalleryAltNext'),
                prevEl: container.querySelector('.swiperGalleryAltPrev'),
            },
            slidesPerView: 1,
        });

        swiper.on('slideChange', () => {
            currentSlide.textContent = String(swiper.realIndex + 1);
        });
    });

    // Homepage
    document.querySelectorAll('.swiperHomeSlider').forEach((slider) => {
        const container = slider.closest('.swiperHomeBlock');

        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination, A11y, Autoplay, EffectFade],
            a11y: {
                enabled: true,
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            navigation: {
                nextEl: container.querySelector('.swiperHomeNext'),
                prevEl: container.querySelector('.swiperHomePrev'),
            },
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                clickable: true,
                enabled: false,
            },
            breakpoints: {
                768: {
                    pagination: {
                        enabled: true,
                    },
                },
            },
            slidesPerView: 1,
        });

        bindAutoplayControl(swiper, container.querySelector('.swiperHomeAutoplay'));

        if (slider.querySelectorAll('.swiper-slide').length <= 1) {
            const autoplayButton = container.querySelector('.swiperHomeAutoplay');
            const buttonWrap = container.querySelector('.slider-button-wrap');

            autoplayButton.hidden = true;
            if (buttonWrap) {
                buttonWrap.style.opacity = '0';
            }
        }
    });

    // Spotlight
    document.querySelectorAll('.swiperSpotlightSlider').forEach((slider) => {
        const container = slider.closest('.swiperSpotlightBlock');

        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination, A11y, Autoplay, EffectFade],
            a11y: {
                enabled: true,
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            navigation: {
                nextEl: container.querySelector('.swiperSpotlightNext'),
                prevEl: container.querySelector('.swiperSpotlightPrev'),
            },
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                clickable: true,
            },
            slidesPerView: 1,
        });

        bindAutoplayControl(swiper, container.querySelector('.swiperSpotlightAutoplay'));

        if (slider.querySelectorAll('.swiper-slide').length <= 1) {
            container.querySelector('.swiperSpotlightAutoplay').hidden = true;
        }
    });

    // Testimonials
    document.querySelectorAll('.swiperTestimonialsSlider').forEach((slider) => {
        const container = slider.closest('.swiperTestimonialsBlock');

        const swiper = new Swiper(slider, {
            modules: [Navigation, A11y, Autoplay, EffectFade],
            a11y: {
                enabled: true,
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: false,
            navigation: {
                nextEl: container.querySelector('.swiperTestimonialsNext'),
                prevEl: container.querySelector('.swiperTestimonialsPrev'),
            },
            slidesPerView: 1,
        });

        bindAutoplayControl(swiper, container.querySelector('.swiperTestimonialsAutoplay'));

        if (slider.querySelectorAll('.swiper-slide').length <= 1) {
            container.querySelector('.swiperTestimonialsAutoplay').hidden = true;
        }
    });

    const variableSliders = [];

    // Variable-width gallery
    document.querySelectorAll('.swiperVariableSlider').forEach((slider) => {
        const swiper = new Swiper(slider, {
            modules: [A11y],
            a11y: {
                enabled: true,
            },
            loop: false,
            slidesPerView: 'auto',
            breakpoints: {
                0: {
                    spaceBetween: 16,
                },
                992: {
                    spaceBetween: 30,
                },
            },
        });

        variableSliders.push(swiper);
    });

    document.querySelectorAll('.swiperVariableBlock').forEach((block) => {
        const previousButton = block.querySelector('.swiperVariablePrev');
        const nextButton = block.querySelector('.swiperVariableNext');

        const getActiveSlider = () => {
            const activePanel = block.querySelector('.slider-variable-tab-panel.__active');
            const activeSlider = activePanel?.querySelector('.swiperVariableSlider');

            return activeSlider ? activeSlider.swiper : block.querySelector('.swiperVariableSlider')?.swiper;
        };

        const updateNavigation = () => {
            const swiper = getActiveSlider();

            if (!swiper) {
                return;
            }

            [
                [previousButton, swiper.isBeginning],
                [nextButton, swiper.isEnd],
            ].forEach(([button, disabled]) => {
                if (button) {
                    button.disabled = disabled;
                    button.classList.toggle('swiper-button-disabled', disabled);
                }
            });
        };

        previousButton?.addEventListener('click', () => {
            getActiveSlider()?.slidePrev();
        });

        nextButton?.addEventListener('click', () => {
            getActiveSlider()?.slideNext();
        });

        variableSliders
            .filter((swiper) => block.contains(swiper.el))
            .forEach((swiper) => {
                swiper.on('slideChange update resize', updateNavigation);
            });

        block.addEventListener('tabs:shown', (event) => {
            const slider = event.target.querySelector('.swiperVariableSlider');

            slider?.swiper?.update();
            updateNavigation();
        });

        updateNavigation();
    });
});
